export default function Undo() {
  return (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.8882 4.27832C12.4273 3.56306 11.8434 2.94251 11.1675 2.44124L12.6667 0.934814H8.30352V5.319L10.342 3.2707C11.887 4.35341 12.8454 6.14669 12.8454 8.06521C12.8454 11.2884 10.2231 13.9106 7 13.9106C3.77688 13.9106 1.15465 11.2883 1.15465 8.06521C1.15465 7.27701 1.30868 6.5126 1.61246 5.79326L0.548765 5.34406C0.184628 6.20631 0 7.12183 0 8.06521C0 11.925 3.14017 15.0652 7 15.0652C10.8598 15.0652 14 11.925 14 8.06521C14 6.71663 13.6155 5.40718 12.8882 4.27832Z" fill="#191936" />
    </svg>
  )
}
